import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { ShareDataService } from 'src/providers/sharedata.service';
import { ShareModel } from 'src/models/share.model';
import { Router } from '@angular/router';
import { RestApiService } from 'src/services/rest-api.service';
import { TableModel } from 'src/models/table.model';
import { Subscription } from 'rxjs-compat';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-20%)', opacity: 0 }),
        animate('250ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('250ms', style({ transform: 'translateY(-20%)', opacity: 0 }))
      ])
    ])
  ]
})
export class AppComponent implements OnInit {

  title = 'SepidzDigitalMenu';
  isToggledUppercase = false;
  hideComponents = false;
  hideGuides = false;
  hideCDK = false;
  selectedthem = 2;
  isTestScreen = false;
  subscription: Subscription;
  constructor(
    public translate: TranslateService,
    public share: ShareDataService,
    private storageManager: LocalStoreManager,
    private router: Router,
    private api: RestApiService<any>,
  ) {
    this.share.getSetting();
    this.storageManager.initialiseStorageSyncListener();
    this.share.goodsGroupList();
  }
  setLanguage(lan: string) {
    this.share.sharemodel.language = (!lan) ? 'FA' : 'EN';
    this.translate.setDefaultLang(lan);
    this.translate.use(lan);
    this.storageManager.savePermanentData(lan, 'Language');
    switch (lan) {
      case 'FA': {
        this.share.sharemodel.isrtl = true;
        break;
      }
      case 'EN': {
        this.share.sharemodel.isrtl = false;
        break;
      }
      default: {
        this.translate.setDefaultLang('FA');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        break;
      }
    }
  }
  go(url: string) {
    this.router.navigate([url]);
  }
  ngOnInit() {
    this.share.sharemodel = new ShareModel();
    this.share.sharemodel.language = this.storageManager.getData(
      'Language'
    );
    switch (this.storageManager.getData('Language')) {
      case 'FA': {
        this.translate.setDefaultLang('EN');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        this.share.sharemodel.language = 'FA';

        break;
      }
      case 'EN': {
        this.translate.setDefaultLang('FA');
        this.translate.use('EN');
        this.share.sharemodel.isrtl = false;
        this.share.sharemodel.language = 'FA';

        break;
      }
      default: {
        this.translate.setDefaultLang('EN');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        this.share.sharemodel.language = 'FA';

        break;
      }
    }

    if (document.body.classList.contains('button-uppercase')) {
      this.isToggledUppercase = true;
    } else if (window.localStorage.getItem('isToggledUppercase')) {
      this.isToggledUppercase = JSON.parse(
        window.localStorage.getItem('isToggledUppercase')
      );
    }
  }
  getTableList() {
    this.api.getEntity<TableModel[]>('AllTables').subscribe(res => {
      this.share.tableList = res;
    });
  }
}
